import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button, Modal } from "react-bootstrap";
import { StarRating, TextArea } from "@components";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
// import styles from "./styles/ReviewModal.module.css";
import * as Yup from "yup";
import {
  checkUserReviewAction,
  checkUserReviewActions,
  clearCourseReviewsAction,
  submitReviewCourseAction,
  updateReviewCourseAction,
} from "@redux/modules/review/slices";
import { checkEnrollmentAction } from "@redux/actions";

const ReviewModal = ({ show, courseId, myRating, onClose }) => {
  // state

  const { data: enrollmentInfo, isEnrolled } = useSelector(
    (state) => state.enrollment.checkEnrollment
  );
  const validateSchema = Yup.object().shape({
    enrollmentId: Yup.string(),
    content: Yup.string().trim().required("Content is required"),
    rating: Yup.number().required("Rating is required"),
  });

  const initialValues = {
    enrollmentId: "",
    content: "",
    rating: "",
  };

  useEffect(() => {
    return () => {
      console.log("reser");
      resetForm({ initialValues, values: initialValues });
      dispatch(clearCourseReviewsAction());
      dispatch(checkUserReviewActions.reset());
    };
  }, [courseId]);

  const dispatch = useDispatch();
  // variables
  const { checkUserReview } = useSelector((state) => state.review);

  const {
    userReview,
    prevReview,
    isSuccess: isCheckUserReviewSuccess,
    processing: processingCheck,
  } = checkUserReview;

  const { id: userReviewId } = userReview || {};

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    resetForm,
    setValues,
    values,
    errors,
    touched,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: validateSchema,
    onSubmit: (values) => {
      if (myRating > 0) {
        const payload = {
          review: {
            content: values.content,
            rating: values.rating,
            reviewId: userReviewId,
          },
          courseId,
        };

        dispatch(updateReviewCourseAction(payload));
      } else {
        dispatch(
          submitReviewCourseAction({
            review: { ...values, enrollmentId: enrollmentInfo.id },
            courseId: courseId,
          })
        );
      }

      //   onSubmit();
      onClose();
    },
  });
  // logics before hooks
  useEffect(() => {
    dispatch(checkUserReviewAction(courseId));
    dispatch(checkEnrollmentAction(courseId));
  }, []);
  // hooks
  useEffect(() => {
    if (userReview) {
      setValues({ content: userReview.content, rating: userReview.rating });
    }
  }, [userReview]);
  // logics

  console.log(userReview);
  // UI partials

  // effects

  // render
  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title className="h5">Review this course</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center">
          <div className={"fs-4 mb-4"}>
            <StarRating
              active
              numRating={+values.rating}
              onChange={(val) => setFieldValue("rating", +val)}
            />
            {touched.rating || (touched.rating && errors.rating) ? (
              <p className="fs-6 text-center m-0 text-danger">
                <small>{errors.rating}</small>
              </p>
            ) : null}
          </div>

          <TextArea
            name="content"
            type="textarea"
            placeholder="Add a public comment"
            rows={5}
            value={values.content}
            onChange={handleChange}
            onBlur={handleBlur}
            autoComplete="off"
            touchedValue={touched.content}
            errorsValue={errors.content}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

/* required: display name */
ReviewModal.displayName = "ReviewModal";

/* required: props types */
ReviewModal.propTypes = {};

/* required: default props */
ReviewModal.defaultProps = {};

export { ReviewModal };
